import React, { Fragment } from "react";
import classnames from "classnames";
import { Link } from "../../Link";
import styles from "../styles/PlanSelectButtons.module.scss";

type Props = {
  isUpdateSubscription: boolean;
  selectedPlanType: string;
  setSelectedPlanType: (plan: string) => void;
};

export const planTypes = { personal: "personal", family: "family" };

export const PlanSelectButtons: React.FC<Props> = (props) => {
  const { isUpdateSubscription, selectedPlanType, setSelectedPlanType } = props;

  return (
    <Fragment>
      {!isUpdateSubscription && (
        <Link className={styles.businessLink} href="business/checkout">
          Looking for Ecologi for Business?
        </Link>
      )}
      <div
        className={classnames(styles.planTypeButtons, {
          [styles.planTypeButtonsFamily]: selectedPlanType === planTypes.family,
          [styles.noBusinessButton]: isUpdateSubscription,
        })}
      >
        <button
          className={classnames(styles.planTypeButton, {
            [styles.planTypeButtonActive]:
              selectedPlanType === planTypes.personal,
          })}
          onClick={(e) => {
            e.preventDefault();
            e.currentTarget.blur();
            setSelectedPlanType(planTypes.personal);
          }}
          title="View personal plans"
        >
          Personal plans
        </button>
        <button
          className={classnames(styles.planTypeButton, {
            [styles.planTypeButtonActive]:
              selectedPlanType === planTypes.family,
          })}
          onClick={(e) => {
            e.preventDefault();
            e.currentTarget.blur();
            setSelectedPlanType(planTypes.family);
          }}
          title="Build a family plan"
        >
          Family plan
        </button>
      </div>
    </Fragment>
  );
};
